import type { NextApiRequest } from 'next';
import type { Session } from 'next-auth';
import { RequestInit } from './ApiUtils';

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
export type ContentType =
  | 'application/json'
  | 'application/pdf'
  | 'application/octet-stream'
  | 'multipart/form-data'
  | 'application/json-patch+json';

export enum HttpMethods {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
}

export enum ContentTypes {
  JSON = 'application/json',
  PDF = 'application/pdf',
  OCTECTSTREAM = 'application/octet-stream',
  FORMDATA = 'multipart/form-data',
  JSONPATCH = 'application/json-patch+json',
}
export interface configParameters {
  method: HttpMethod;
  headers: {
    'Content-Type': ContentType;
    Authorization: string;
  };
  body: string | null;
}

export interface ApiConfig {
  setConfig(props: {
    method: HttpMethod;
    contentType: ContentType;
    token: string | undefined;
    body?: string | null;
  }): RequestInit;
}

export interface ExtendedApiRequest extends NextApiRequest {
  userSession: Session | null;
}
